export default "__VITE_ASSET__rdVR_GZW__"